"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BACK_ICON = exports.HEADER = exports.FOOTER = exports.CONTENT = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs3 = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    CONTENT = (0, _cxs3["default"])((0, _defineProperty2["default"])({
  display: "flex",
  flexDirection: "column",
  overflowY: "auto"
}, _vars.MEDIA_QUERIES.small, {
  paddingLeft: "0px",
  paddingRight: "0px"
}));

exports.CONTENT = CONTENT;
var FOOTER = (0, _cxs3["default"])((0, _defineProperty2["default"])({
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "35px",
  minHeight: "50px",
  flexWrap: "wrap",
  "> button:first-of-type:not(:last-of-type)": {
    marginRight: "10px"
  }
}, _vars.MEDIA_QUERIES.medium, {
  marginTop: "25px"
}));
exports.FOOTER = FOOTER;

var HEADER = function HEADER(a) {
  var b = a.showBackBtn;
  return (0, _cxs3["default"])({
    marginBottom: "20px",
    marginTop: b ? "20px" : void 0
  });
};

exports.HEADER = HEADER;
var BACK_ICON = (0, _cxs3["default"])({
  cursor: "pointer",
  position: "absolute",
  top: "22px",
  left: "25px"
});
exports.BACK_ICON = BACK_ICON;